import {
  useParams,
  useState,
  FaEye,
  Select,
  ToastContainer,
  TbNumbers,
  overlayStyle,
  loaderStyle,
  FaTrash,
  FaPlus,
} from "../../common/common";
import { useErrorContext } from "../../context/ErrorContext";
import useNavigation from "../../common/useNavigation";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";
import Button from "react-bootstrap/Button";
import MidAddProductPriceList from "../../middleware/Products/MidAddProductPriceList";

const ProductPriceList = () => {
  const { type } = useParams();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  const { navigateProductPriceList, navigatePlans } = useNavigation();
  const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
  const { error } = useErrorContext();
  const {
    values,
    users,
    userPlan,
    handleChange,
    handleSubmit,
    isLoading,
    countryData,
    stateData,
    handleGetCities,
    handleGetState,
    distributors,
    productVariants,
    products,
    handleVariantChange,
    handleProductChange,
    addVariant,
    removeVariant,
    handleProductPriceListSubmit,
    handleSelectChange,
  } = MidAddProductPriceList(type);

  if (Array.isArray(users) && users.length > 0) {
    var AppID = users[0]["AppID"];
    var ProfilePic = users[0]["ProfilePic"];
    var usertype = users[0]["UserType"];
    var username = users[0]["FullName"];
    var ActiveUser = users[0]["Status"];
  }
  if (Array.isArray(userPlan) && userPlan.length > 0) {
    var planID = userPlan[0]["plan_id"];
  }

  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? "w-0  md:w-1/5" : "w-0"}`}>
        <Sidebar
          handleSideBar={handlesetIssidebarOpen}
          issidebarOpen={issidebarOpen}
          UserTypeData={usertype}
          userName={username}
          appID={AppID}
          profilePic={ProfilePic}
          currentUserType={type}
          currentplan={planID}
          ActiveUser={ActiveUser}
        />
      </div>
      <div
        className={`${issidebarOpen ? "w-full  md:w-[80%]" : "ml-20 w-full"} `}
      >
        <Topbar
          issidebarOpen={issidebarOpen}
          UserTypeData={usertype}
          currentUserType={type}
        />
        <div className="w-full ">
          <div className="col-start-1 col-end-13">
            <div className=" p-2 text-xl text-[#1e3a8a]">
              <div className="px-3">
                <h1 className=" text-lg text-theme-color-text font-bold">
                  Product Price Lists
                </h1>
                <p className=" text-gray-600 text-[16px] ">
                  Create price lists for products by state or by distributor
                </p>
              </div>
            </div>
          </div>

          {ActiveUser === 1 ? (
            <div className="border-0 flex-row rounded-xl m-3  bg-white shadow-xs ">
              <div className=" relative flex flex-col min-w-0 break-words">
                <div className="p-4">
                  <div className="flex flex-row lg:flex-row justify-between items-center mb-4">
                    <h5 className=" capitalize text-xl font-bold mb-0">
                      Add Price List
                    </h5>
                    <button
                      type="submit"
                      className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[200px]"
                    >
                      <span
                        className="relative text-md text-black font-semibold pl-0"
                        onClick={navigateProductPriceList}
                      >
                        View All Price Lists
                      </span>
                      <div className=" items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl hidden lg:block py-3 ">
                        <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                      </div>
                    </button>
                  </div>
                  <form method="POST" onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Price List Configuration Section */}
                      <div className="grid grid-cols-1 lg:grid-cols-1 gap-3 my-3 col-span-2">
                        {/* Radio buttons for price list type */}
                        <div className="mb-6">
                          <label className="block my-3">
                            <span className="block text-sm font-medium text-slate-700">
                              Price List Type
                            </span>
                          </label>
                          <div className="flex items-center space-x-4">
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                name="priceListType"
                                value="state"
                                checked={values.priceListType === "state"}
                                onChange={handleChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                              />
                              <span className="ml-2 text-gray-700">
                                By State
                              </span>
                            </label>
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                name="priceListType"
                                value="distributor"
                                checked={values.priceListType === "distributor"}
                                onChange={handleChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                              />
                              <span className="ml-2 text-gray-700">
                                By Distributor
                              </span>
                            </label>
                          </div>
                        </div>

                        {values.priceListType === "state" && (
                          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                            {users.length > 0 && users[0]?.IsIndian === 0 ? (
                              <div>
                                <label className="block w-full">
                                  <span className="block text-sm font-medium text-[#333333]">
                                    Country
                                  </span>
                                </label>
                                <Select
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                    }
                                  }}
                                  name="country"
                                  id="country"
                                  options={countryData}
                                  placeholder="Select Country"
                                  onChange={handleGetState}
                                />
                              </div>
                            ) : null}

                            <div className="mr-5 my-2">
                              <label className="text-sm text-[#02264a] font-semibold">
                                States{" "}
                                <span className="text-red-700 "> * </span>{" "}
                              </label>
                              <Select
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                }}
                                name="state"
                                id="state"
                                className=" my-1"
                                options={stateData}
                                placeholder="Select State"
                                onChange={handleGetCities}
                              />
                            </div>
                          </div>
                        )}

                        {/* Distributor field - only shown when 'By Distributor' is selected */}
                        {values.priceListType === "distributor" && (
                          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                            <div>
                              <label className="block my-3">
                                <span className="block text-sm font-medium text-slate-700">
                                  Distributor {!values.state}
                                </span>
                              </label>
                              <Select
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                }}
                                options={distributors}
                                name="distributor"
                                value={values.distributor}
                                onChange={(selectedOption) =>
                                  handleSelectChange(
                                    "distributor",
                                    selectedOption,
                                  )
                                }
                                placeholder="Select Distributor"
                                className="w-full"
                                isDisabled={
                                  !values.priceListType === "distributor"
                                }
                              />
                              {error.distributor && (
                                <p className="my-2 px-2 text-red-600 text-xs">
                                  {error.distributor}
                                </p>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Product Variant and Price fields */}
                        <div className="mt-6">
                          <h4 className="text-lg font-semibold mb-4">
                            Product Variant Prices
                          </h4>
                          <div className="space-y-4">
                            {values.variants.map((variant, index) => (
                              <div
                                key={index}
                                className="grid grid-cols-1 lg:grid-cols-4 gap-3 items-end"
                              >
                                <div>
                                  <label className="block my-3">
                                    <span className="block text-sm font-medium text-slate-700">
                                      Product
                                    </span>
                                  </label>
                                  <Select
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                      }
                                    }}
                                    options={products.filter(
                                      (product) => product.status !== 0,
                                    )}
                                    value={variant.productId}
                                    onChange={(selectedOption) =>
                                      handleProductChange(
                                        index,
                                        "productId",
                                        selectedOption,
                                      )
                                    }
                                    placeholder="Select Product"
                                    className="w-full"
                                  />
                                </div>
                                <div>
                                  <label className="block my-3">
                                    <span className="block text-sm font-medium text-slate-700">
                                      Product Variant
                                    </span>
                                  </label>
                                  <Select
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                      }
                                    }}
                                    options={productVariants}
                                    value={variant.variantId}
                                    onChange={(selectedOption) =>
                                      handleVariantChange(
                                        index,
                                        "variantId",
                                        selectedOption,
                                      )
                                    }
                                    placeholder="Select Variant"
                                    className="w-full"
                                  />
                                </div>

                                <div>
                                  <label className="block my-3">
                                    <span className="block text-sm font-medium text-slate-700">
                                      Price
                                    </span>
                                  </label>
                                  <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                    <TbNumbers className="text-gray-400" />
                                    <input
                                      className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                                      type="number"
                                      placeholder="Enter Price"
                                      value={variant.price}
                                      onChange={(e) =>
                                        handleVariantChange(
                                          index,
                                          "price",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                  {error[`price_${index}`] && (
                                    <p className="my-2 px-2 text-red-600 text-xs">
                                      {error[`price_${index}`]}
                                    </p>
                                  )}
                                </div>

                                <div className="flex space-x-2">
                                  <button
                                    type="button"
                                    onClick={() => removeVariant(index)}
                                    className="flex items-center justify-center p-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200"
                                    disabled={values.variants.length <= 1}
                                  >
                                    <FaTrash className="h-4 w-4" />
                                  </button>
                                </div>
                              </div>
                            ))}
                            <button
                              type="button"
                              onClick={addVariant}
                              className="flex items-center space-x-2 px-4 py-2 bg-blue-100 text-blue-600 rounded-md hover:bg-blue-200"
                            >
                              <FaPlus className="h-4 w-4" />
                              <span>Add Variant</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Submit Button */}
                    <div className="flex justify-end">
                      {/* <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductDetailsSubmit}> Submit</Button> */}
                      <Button
                        type="button"
                        className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end"
                        onClick={handleProductPriceListSubmit}
                      >
                        {" "}
                        Save PriceList{" "}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div class="col-start-1 col-end-13  my-5 px-3">
              <div class="flex items-start p-3  bg-red-700  border-[1px] border-l-4 border-red-500 rounded-lg relative">
                <div class="flex-shrink-0 text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-6 h-6"
                    fill="currentcolor"
                    viewBox="0 0 24 24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h2 class="text-lg font-semibold text-white">
                    New Plan Purchased 🎉
                  </h2>
                  <p class="text-white">
                    A new Plan has successfully completed a purchase.
                  </p>
                </div>
                <div class="ml-auto">
                  <button
                    class="bg-white text-blue-600 font-medium px-4 py-2 rounded-lg border border-blue-600 hover:bg-blue-50 transition"
                    onClick={() => {
                      navigatePlans(type);
                    }}
                  >
                    Buy Purchase Plan
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
      {isLoading && (
        <div style={overlayStyle}>
          <div style={loaderStyle}>Loading...</div>
        </div>
      )}
    </div>
  );
};
export default ProductPriceList;
